import { Component, Input } from "@angular/core";
import { ChatMessageFileType } from "../chat-window/chat-window.component";

@Component({
  selector: 'app-file-message-viewer',
  templateUrl: './file-message-viewer.component.html',
  styleUrls: ['./file-message-viewer.component.scss'],
})
export class FileMessageViewerComponent {
  @Input() files: ChatMessageFileType[];
  constructor() {}


getFileType(url: string): string {
  const extensions = {
      audio: ['.mp3', '.wav', '.ogg', '.m4a', '.aac', '.flac'],
      image: ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg', '.webp'],
      video: ['.mp4', '.avi', '.mkv', '.webm', '.mov'],
      pdf: ['.pdf'],
      word: ['.doc', '.docx'],
      ppt: ['.ppt', '.pptx'],
      excel: ['.xls', '.xlsx', '.ods']
  };

  for (let [type, exts] of Object.entries(extensions)) {
      if (exts.some(ext => url.endsWith(ext))) {
          return type;
      }
  }
  
  return 'unknown';
}
}